import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/paymentMethod'
import actions from '../actions/paymentMethod'

class Container extends React.Component {

  constructor(props) {
    super(props)

    props.fetch()
    props.fetchDocumentTypes()
  }

  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {
    fetch: PropTypes.func.isRequired,
    fetchDocumentTypes: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.profile.paymentMethod
  const number = data.getIn(['selected', 'number'])
  const expiry = data.getIn(['selected', 'expiry'])
  const cvc = data.getIn(['selected', 'cvc'])
  const cardholderName = data.getIn(['selected', 'cardholderName'])
  const documentType = data.getIn(['selected', 'documentType'])
  const documentNumber = data.getIn(['selected', 'documentNumber'])
  return {
    cards: data.get('cards').toArray(),
    number: number.get('value'),
    expiry: expiry.get('value'),
    cvc: cvc.get('value'),
    cardholderName: cardholderName.get('value'),
    documentTypes: data.get('documentTypes').toArray(),
    documentType: documentType.get('value'),
    documentNumber: documentNumber.get('value'),
    addDialogShow: data.get('addDialogShow'),
    removeDialogShow: data.get('removeDialogShow'),
    markDialogShow: data.get('markDialogShow'),
    isFetching: data.get('isFetching'),
    isSaving: data.get('isSaving'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchDocumentTypes: () => dispatch(actions.fetchDocumentTypes()),
    fetch: () => dispatch(actions.fetch()),
    setCardNumber: value => dispatch(actions.setCardNumber(value)),
    setExpiry: value => dispatch(actions.setExpiry(value)),
    setCVC: value => dispatch(actions.setCVC(value)),
    setCardholderName: value => dispatch(actions.setCardholderName(value)),
    setDocumentType: value => dispatch(actions.setDocumentType(value)),
    setDocumentNumber: value => dispatch(actions.setDocumentNumber(value)),
    add: () => dispatch(actions.add()),
    saveAdd: type => dispatch(actions.saveAdd(type)),
    closeAddDialog: () => dispatch(actions.closeAddDialog()),
    remove: () => dispatch(actions.remove()),
    saveRemove: id => dispatch(actions.saveRemove(id)),
    closeRemoveDialog: () => dispatch(actions.closeRemoveDialog()),
    mark: () => dispatch(actions.mark()),
    saveMark: id => dispatch(actions.saveMark(id)),
    closeMarkDialog: () => dispatch(actions.closeMarkDialog()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/profile/containers/paymentMethod.js